export const KEY_SHOW_LOCATION_TOURTIP = "showLocationTourtip";

export interface Input {
  open?: boolean;
}

export interface State {
  opened: boolean;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      opened: false,
    };
  }

  onCollapse() {
    this.state.opened = false;
    window?.localStorage?.setItem(KEY_SHOW_LOCATION_TOURTIP, "false");
  }

  onMount() {
    this.showTourtipOnce();
  }

  showTourtipOnce() {
    const shouldOpen = window?.localStorage?.getItem(KEY_SHOW_LOCATION_TOURTIP);
    if (shouldOpen !== "false") {
      this.state.opened = true;
      window?.localStorage?.setItem(KEY_SHOW_LOCATION_TOURTIP, "false");
    }
  }
}
